import { Common } from './core/common';
import { ActivityTypeEnums } from './models/enums/ActivityType';
let _common: Common;

export function IsGuid(value: string): boolean {
    const regexGuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
    return regexGuid.test(value);
}

export function newGuid() {
    let guid: string = '';
    while (!IsGuid(guid)) {
        guid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c: string) => {
            /* tslint:disable */
            const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
    return guid;
}

export function getQueryStringParameter(key: string): string {
    const search: RegExpExecArray | null = (new RegExp(key + '=([^&]+)')).exec(window.location.search);
    if (search) {
        return search[1];
    }
    return '';
}

export function sleep(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export function fileSize(bytes: any, si: any) {
    var thresh = si ? 1000 : 1024;
    if (Math.abs(bytes) < thresh) {
        return bytes + ' B';
    }
    var units = si
        ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
        : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
    var u = -1;
    do {
        bytes /= thresh;
        ++u;
    } while (Math.abs(bytes) >= thresh && u < units.length - 1);
    return bytes.toFixed(1) + ' ' + units[u];
}

export const setTitleAndLogos = () => {
    const organizationAbbreviation = localStorage.getItem("org_Abbreviation");
    const organizationLogo = localStorage.getItem("org_logo");

    // Fallback olarak kullanacağımız yerel favicon dosyası:
    const favico = `${process.env.PUBLIC_URL}/images/constructor/favicon.ico`;

    // Kurum kısaltması boş değilse, sayfa başlığını güncelle
    if (organizationAbbreviation) {
        const titleElement = document.getElementById("egitim365_title");
        if (titleElement) {
            titleElement.innerText = organizationAbbreviation;
        }
    }

    // Favicon link elemanını al
    const logoElement = document.getElementById("org_logo_url") as HTMLLinkElement;
    if (!logoElement) return;

    // Eğer organizationLogo yoksa doğrudan fallback favicon kullan
    if (!organizationLogo) {
        logoElement.href = favico;
        return;
    }

    // organizationLogo varsa, yüklenebilir mi diye test edelim
    const testImage = new Image();
    testImage.onload = () => {
        // Logo geçerli, organizationLogo'yu kullan
        logoElement.href = organizationLogo;
    };
    testImage.onerror = () => {
        // Logo yüklenemedi, fallback favicon'a dön
        logoElement.href = favico;
    };
    testImage.src = organizationLogo;
};


export function timeFormat(h: number, m: number = 0, s: number = 0): string {
    var time = new Date();
    time.setHours(h, m, s, 0);
    var format = time.toTimeString().substring(0, 8);
    if (format.startsWith('00:')) {
        format = format.substring(3);
    }
    return format;
}

export function bitFormat(bit: number): string {
    var thresh = 1024;
    if (Math.abs(bit) < (thresh * 8)) {
        return bit + ' Bit';
    }
    var units = ['KBit', 'MBit', 'GBit', 'TBit'];
    var u = -1;
    do {
        bit /= thresh;
        ++u;
    } while (Math.abs(bit) >= thresh && u < units.length - 1);
    return bit.toFixed(1) + ' ' + units[u];
}

export function getAbbr(value: string): string {
    var abbr = '';
    if (value) {
        var arr = value.trim().split(' ');
        if (arr.length === 1) {
            abbr = arr[0].charAt(0).toUpperCase();
        } else if (arr.length > 1) {
            abbr = arr[0].charAt(0).toUpperCase() + arr[1].charAt(0).toUpperCase();
        }
    }
    return abbr;
}

export function containsText(withinText: string, searchText: string, caseSensitive: boolean = false, accentSensitive: boolean = false): boolean {
    if (!caseSensitive) {
        searchText = searchText.toLocaleLowerCase();
        withinText = withinText.toLocaleLowerCase();
    }

    if (!accentSensitive && typeof String.prototype.normalize === 'function') {
        searchText = searchText.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        withinText = withinText.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        // İ and ı cannot be normalized to I and i.
        withinText = withinText.replace('İ', 'I').replace('ı', 'i');
        searchText = searchText.replace('İ', 'I').replace('ı', 'i');
    }

    return withinText.indexOf(searchText) > -1;
}

export function dateCheck(from: string, to: string, check: string) {
    var fDate, lDate, cDate;
    fDate = Date.parse(from);
    lDate = Date.parse(to);
    cDate = Date.parse(check);

    if ((cDate <= lDate && cDate >= fDate)) {
        return true;
    }
    return false;
}

export function ActivityTypeByEnums(activityType: ActivityTypeEnums): string {
    switch (activityType) {
        case ActivityTypeEnums.Assignment:
            return 'r_activity_type_Assignment';
        case ActivityTypeEnums.Document:
            return 'r_activity_type_Document';
        case ActivityTypeEnums.Forum:
            return 'r_activity_type_Forum';
        case ActivityTypeEnums.VirtualClass:
            return 'r_activity_type_VirtualClass';
        case ActivityTypeEnums.Video:
            return 'r_activity_type_Video';
        case ActivityTypeEnums.Survey:
            return 'r_activity_type_Survey';
        case ActivityTypeEnums.Other:
            return 'r_activity_type_Other';
        case ActivityTypeEnums.Course:
            return 'r_activity_type_Course';
        case ActivityTypeEnums.Elesson:
            return 'r_activity_type_Elesson';
        case ActivityTypeEnums.Exam:
            return 'r_activity_type_Exam';
        case ActivityTypeEnums.Container:
            return 'r_activity_type_Container';
        case ActivityTypeEnums.MorpaActivity:
            return 'r_activity_type_MorpaActivity';
        case ActivityTypeEnums.GenericActivity:
            return 'r_activity_type_GenericActivity';
        case ActivityTypeEnums.LinkActivity:
            return 'r_activity_type_LinkActivity';
        case ActivityTypeEnums.Dictionary:
            return 'r_activity_type_Dictionary';
        case ActivityTypeEnums.TelegramActivity:
            return 'r_activity_type_TelegramActivity';
        case ActivityTypeEnums.Reading:
            return 'r_activity_type_Reading';
        case ActivityTypeEnums.LTIActivity:
            return 'r_activity_type_LTIActivity';
        case ActivityTypeEnums.Project:
            return 'r_activity_type_Project';
        case ActivityTypeEnums.InformationNote:
            return 'r_activity_type_InformationNote';
        default:
            return '';
    }
};

export function findTerm(activityTermWeekId: string, termWeeks: any[]): string {
    if (termWeeks && termWeeks.length > 0) {
        const termWeek = termWeeks.find((x) => x.termWeekId === activityTermWeekId);
        if (termWeek) {
            const index = termWeeks.indexOf(termWeek);
            return termWeeks[index].week;
        }
    }
    return '';
}

export function getTermName(activityTermWeekId: string, termWeeks: any[], translator: any): string {
    const termData = findTerm(activityTermWeekId, termWeeks);

    if (!termData) {
        return '';
    } else {
        return `${termData}. ${translator.t('r_time_week')}`;
    }
}